import styles from './style.module.css';
import deliveryProfile from "../../../../../assets/delivery-man.png";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Tag from '../../../../../design-system/lib/Tag';
import { adsigne, box_gray, CALL, COPY, Dcall, Dcar, Demail, Dvehicle, INFO_CIRCLE } from '../../../../../assets';
import { Voip_OutgoingCall } from '../../../../../Redux/actions/actions';
import { get_id } from '../../../../../helper/UserData/userdate';
import { ClickAwayListener, Tooltip, TooltipProps, tooltipClasses } from 'newmaterial-ui';
import { styled } from 'newmaterial-ui/styles';
import React from 'react';
import { isEmpty } from 'lodash';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { snack } from '../../../../../utils/SnackbarUtilsConfigurator';
import Button from '../../../../../design-system/lib/Button';


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip  {...props} classes={{ popper: className }} />
))(({ theme }) => ({
      [`&.${tooltipClasses.popper}`]: {
    marginLeft: '-11px !important', // 👈 فاصله از سمت راست
  },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: ' #fff',
        borderRadius: "8px",
        padding: "8px",
        border: 'none',
        boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.24)",
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: "auto",
        fontSize: theme.typography.pxToRem(12),
        marginBottom: "0px !important",
        height: "auto" 
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "white",
        marginInlineStart:"12px"
    },
}));



export const DriversListItem = ({ avatarPhoto, ordersCount, isOnline, name, onClick, username, phone, id, email, vehicle, vehicleTypes }) => {
    const dispatch = useDispatch();
    const repositoryRegexText = useSelector((state) => state.OrderList.search.regexText)
    const { t } = useTranslation();
    const [forceHover, setForceHover] = React.useState(false);
    const [infoOpen, setInfoOpen] = React.useState(false);

    function makeOutgoingCall(e) {
        e.stopPropagation();

        dispatch(Voip_OutgoingCall(dispatch, {
            "to": phone,
            "orderId": null,
            "customerId": null,
            "driverId": id,
            "dispatcherId": get_id()
        }))

    }


      React.useEffect(() => {

        if(infoOpen){
            const myEvent = new CustomEvent("closeDriverInfo", { detail: id });
             document.dispatchEvent(myEvent);
        }
    
    
    
      }, [infoOpen])


        React.useEffect(() => {
      
       try {
           document.addEventListener('closeDriverInfo', (res) => {

             //
            if(res.detail != id){
                 setInfoOpen(false)
                 setForceHover(false)
            }
           


             //
           })
           return () => {
             document.removeEventListener("closeDriverInfo",()=>{
               
             });
         };
       } catch (error) {
        
       }
        }, [])

    return <div className={`${styles.DriversListItemContainer} ${(forceHover) && styles.forceHover}`} onClick={onClick} >
        <img src={avatarPhoto.length > 0 ? avatarPhoto : deliveryProfile} onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = deliveryProfile;
        }} alt="" className={clsx(styles.avatar, (ordersCount > 0 && isOnline) && styles.withOrder, (ordersCount == 0 && isOnline) && styles.noOrder)} />
        <div className={styles.twoColumnContaiiner}>
            <span className={styles.name}>
                {name}
            </span>
            <span className={styles.orders}>
                <img style={{ width: "14px", height: "14px" }} src={adsigne} />{username} {/* {ordersCount} {t("Orders")} */}

                <span style={{ height: "16px", width: "1px", backgroundColor: "rgba(128, 128, 128, 0.2)", margin: "0px 4px" }} />

                <img style={{ width: "14px", height: "14px" }} src={box_gray} />{ordersCount} {/* {ordersCount} {t("Orders")} */}
            </span>
        </div>
        <ClickAwayListener onClickAway={() => {
            setInfoOpen(false); setTimeout(() => {
                setForceHover(false)
            }, 150);
        }}>
            <div className={styles.twoHoverBtn}>
                <HtmlTooltip open={infoOpen} arrow title={
                    <div className={styles.popUpContainer} onClick={(e) => { e.stopPropagation(); }} >
                        <div className={styles.popUpItemContainer}>
                            <img src={Dcall} />
                            <span style={{ fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)", marginInlineEnd: "4px" }}  > {phone}</span>
                            <CopyToClipboard text={phone}
                                onCopy={() => snack.success(t("Saved"))}>
                                <img src={COPY} style={{ marginInlineStart: "auto", cursor: "pointer" }} />
                            </CopyToClipboard>
                        </div>
                        {!isEmpty(email) && <div className={styles.popUpItemContainer}>
                            <img src={Demail} />
                            <span style={{ fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)", marginInlineEnd: "4px" }}  > {email}</span>
                            <CopyToClipboard text={email}
                                onCopy={() => snack.success(t("Saved"))}>
                                <img src={COPY} style={{ marginInlineStart: "auto", cursor: "pointer" }} />
                            </CopyToClipboard>
                        </div>}

                        <div className={styles.popUpItemContainer}>
                            <img src={Dcar} />
                            <span style={{ fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)", marginInlineEnd: "auto", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}  > {vehicle?.plate}  <span style={{ height: "16px", width: "1px", backgroundColor: "rgba(128, 128, 128, 0.2)", margin: "0px 4px" }} /> {vehicle?.color + " " + vehicle?.model}</span>
                        </div>
                        <div className={styles.popUpItemContainer}>
                            <img src={Dvehicle} style={{ alignSelf: "start" }} />
                            <span style={{ fontSize: "13px", fontWeight: "400", color: "rgba(36, 36, 36, 1)", marginInlineEnd: "auto", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}  > {vehicleTypes?.map(item => item.title).join(", ")}</span>
                        </div>


                    </div>
                } placement="top" onOpen={() => { }} onClose={() => { }} >
                    <img src={INFO_CIRCLE} className={styles.HoverBtn} onClick={(e) => {
                        e.stopPropagation();
                        let dwsds = !infoOpen
                        setInfoOpen(dwsds);
                        ; setTimeout(() => {
                            setForceHover(dwsds)
                        }, 150);
                    }} />

                </HtmlTooltip>

                {global.config.dispatcherSettings.isVoipActvie && <Button size='Tiny' type='Secondary' icon={CALL} style={{backgroundColor:"white"}}  onClick={makeOutgoingCall} />}
               {!global.config.dispatcherSettings.isVoipActvie &&  <Button size='Tiny' type='Secondary' icon={CALL} style={{backgroundColor:"white"}}  onClick={(e)=>{
                   e.stopPropagation();
                    window.open(url, "_blank");
                }} />}

    
            </div>
        </ClickAwayListener>
    </div>
};




